
import { useTopCurrencies } from '@/composables/useTopCurrencies';
import { computed, defineAsyncComponent, defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import BaseLoadingSpinner from '@/components/BaseLoadingSpinner.vue';
import CurrencyDetailsHistoTable from '@/components/CurrencyDetailsHistoTable.vue';

export default defineComponent({
  name: 'CurrencyDetails',
  components: {
    BaseLoadingSpinner,
    CurrencyDetailsChart: defineAsyncComponent(
      () => import('@/components/CurrencyDetailsChart.vue')
    ),
    CurrencyDetailsHistoTable,
  },
  setup() {
    const { currencies } = useTopCurrencies();
    const route = useRoute();

    const currency = computed(() => {
      if (currencies.value !== null) {
        return (
          currencies.value.find(
            (currency) => currency.name === route.params.symbol
          ) || 'Not found'
        );
      }
      return null;
    });
    return { currency };
  },
});
